








import {Component, Vue, Watch, Prop } from "vue-property-decorator"

@Component({name:"ui-table-header"})
export default class UiTableHeaderComponent extends Vue{
    
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./~/ui-table/src/ui-table-header.vue